import React from "react";
import { OnDemandEvents } from "@glamcorner/gc-types/generated/ipcBusEvents";
import { DesignationPanel, DesignationPanelField } from "../DesignationPanel";
import { SizeRow } from "../../SizeRow";
import { Bus } from "../../../../services/Bus";
import { BuyDesignationInformation } from "../../../../types";
import { numberInCentsToDisplay } from "../../../pricing";

export type BuyDesignationPanelProps = {
  isSelected: boolean;
  onSelect: () => void;
  parentOnSubmitCallback: (callbackFn: () => boolean) => void;
  productCode: string | undefined;
  information: BuyDesignationInformation;
  isAlwaysNew: boolean;

  errors: { size?: string };
  isValid: () => boolean;
  size: string | undefined;
};

export const BuyDesignationPanel: React.FC<BuyDesignationPanelProps> = ({
  isSelected,
  information,
  isAlwaysNew,
  productCode,
  onSelect,
  parentOnSubmitCallback,
  errors,
  isValid,
  size,
}) => {
  parentOnSubmitCallback(() => {
    if (isValid()) {
      const pathname = window.location.pathname;
      // Originally magento would check for 'checkout-cart-configure' class on body
      // We will check the URL instead because the next parameter is the magento quote ID of the item
      // Makes it more of a single edit dependency
      const isEditing = pathname.includes("/checkout/cart/configure");

      if (isEditing) {
        const pathArray = pathname.split("/");
        const lastItemID = pathArray[pathArray.length - 1];

        Bus.broadcast(OnDemandEvents.CartUpdateItem, {
          itemId: lastItemID,
          productCode,
          productType: "Sale",
          postcode: null,
          startDate: null,
          endDate: null,
          size,
        });
        return true;
      } else {
        Bus.broadcast(OnDemandEvents.AddToCart, {
          productCode,
          productType: "Sale",
          postcode: null,
          startDate: null,
          endDate: null,
          inBackupMode: null,
          size,
        });
        return true;
      }
    }

    return false;
  });

  const sizeRowField: DesignationPanelField = {
    label: "Size",
    component: <SizeRow sizes={information.sizes} />,
    error: errors.size,
  };

  const fields = [[sizeRowField]];

  return (
    <DesignationPanel
      isSelected={isSelected}
      title={isAlwaysNew ? "Buy New" : "Buy Pre-Loved"}
      subTitle={`for $${numberInCentsToDisplay(
        information.prices.discountBuyPriceInCents || information.prices.buyPriceInCents
      )}`}
      onSelect={onSelect}
      fields={fields}
    />
  );
};
